import App from './App.vue';
import router from './router';
import i18n from './locales';
import {setupCalendar} from 'v-calendar';
import {createApp} from 'vue';
import {createPinia} from 'pinia';
import Quasar from 'quasar/src/vue-plugin.js';;
import {createGtm} from "@gtm-support/vue-gtm";
import { loadCustomGtmScript } from './analytics/gtm-loader';


import SvgInline from './mega-ui/components/svg-inline.vue';

import './registerServiceWorker';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import quasarUserOptions from './quasar-user-options';

import VueSvgInlinePlugin from "vue-svg-inline-plugin";
import "vue-svg-inline-plugin/src/polyfills";

const pinia = createPinia();

const app = createApp(App);

pinia.use(piniaPluginPersistedstate);
app.use(Quasar, quasarUserOptions)
    .use(pinia)
    .use(i18n)
    .use(router)
    .use(setupCalendar, {});

app.use(
    createGtm({
        id: "GTM-N6WBGBTT",
        enabled: false,
        vueRouter: router,
        defer: false,
        loadScript: false,
        debug: process.env.NODE_ENV !== 'production',
    })
)

app.component('SvgInline', SvgInline);
app.use(VueSvgInlinePlugin);
app.mount('#q-app');
loadCustomGtmScript();
